/*
 * Service-Bewertungen (Trusted Shops Shopbewertungen) — Karussell.
 *
 * Loest das Original-Widget <etrusted-widget> ab. Warum das noetig war und wo
 * die Feeds herkommen: docs/service-reviews-carousel.md.
 *
 * Alle sichtbaren Texte und IDs kommen aus dem JSON-Block der Section
 * (sections/mc-service-reviews.liquid) — hier steht keine Uebersetzung drin.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-mc-service-reviews]';

  /* Trusted Shops liefert zu Service-Bewertungen keinen Kundennamen (der Feed
     hat gar kein consumer-Feld). Wie auf den Produktseiten wird deshalb ein
     Platzhaltername gezeigt — hier deterministisch aus der Review-UUID
     abgeleitet, damit er bei jedem Aufruf und auf jedem Geraet gleich ist. */
  /* Namenspool und Initialen kommen aus dem Config-Block der Section
     (sections/mc-service-reviews.liquid) und damit aus den Locale-Dateien.
     Die Konstanten hier sind nur noch der Notnagel, falls die Section den
     Block einmal nicht mitliefert - vgl. den Dateikopf: im JS-Asset soll
     keine Uebersetzung stehen. */
  var FALLBACK_FIRST_NAMES = ['Alex', 'Chris', 'Jamie', 'Kim', 'Robin', 'Sam', 'Toni'];
  var FALLBACK_INITIALS = 'ABCDEFGHKLMNPRSTVWZ'.split('');
  var FIRST_NAMES = FALLBACK_FIRST_NAMES;
  var INITIALS = FALLBACK_INITIALS;

  function hash(value) {
    var h = 2166136261;
    for (var i = 0; i < value.length; i++) {
      h ^= value.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function applyPlaceholderPool(config) {
    if (config && Array.isArray(config.placeholderNames) && config.placeholderNames.length) {
      FIRST_NAMES = config.placeholderNames;
    }
    if (config && typeof config.placeholderInitials === 'string' && config.placeholderInitials) {
      INITIALS = config.placeholderInitials.split('');
    }
  }

  function placeholderAuthor(id) {
    var h = hash(id || '');
    return FIRST_NAMES[h % FIRST_NAMES.length] + ' ' +
      INITIALS[Math.floor(h / FIRST_NAMES.length) % INITIALS.length] + '.';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function svgNode(tag, attributes) {
    var node = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.keys(attributes).forEach(function (key) {
      node.setAttribute(key, attributes[key]);
    });
    return node;
  }

  function ServiceReviews(root) {
    this.root = root;
    this.section = root.closest('[data-mc-service-reviews-section]') || root;
    this.track = root.querySelector('[data-mc-sr-track]');
    this.prevButton = root.querySelector('[data-mc-sr-nav="prev"]');
    this.nextButton = root.querySelector('[data-mc-sr-nav="next"]');

    var configNode = root.querySelector('[data-mc-sr-config]');
    try {
      this.config = JSON.parse(configNode.textContent);
    } catch (error) {
      this.config = null;
    }
  }

  ServiceReviews.prototype.init = function () {
    if (!this.config || !this.track) return;

    applyPlaceholderPool(this.config);

    /* Ab hier ist klar, dass JS laeuft — Platzhalterkarten zeigen und damit die
       Hoehe reservieren, bevor die Feeds da sind. */
    this.section.hidden = false;

    var self = this;
    if (this.prevButton) {
      this.prevButton.addEventListener('click', function () { self.scrollByCard(-1); });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', function () { self.scrollByCard(1); });
    }
    this.track.addEventListener('scroll', function () { self.updateNav(); }, { passive: true });
    this.onResize = function () { self.updateNav(); };
    window.addEventListener('resize', this.onResize);

    Promise.all([
      this.fetchJson(this.config.reviewsUrl),
      this.fetchJson(this.config.gradesUrl)
    ]).then(function (results) {
      self.render(Array.isArray(results[0]) ? results[0] : [], results[1]);
    });
  };

  ServiceReviews.prototype.destroy = function () {
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  };

  ServiceReviews.prototype.fetchJson = function (url) {
    if (!url) return Promise.resolve(null);
    return fetch(url, { credentials: 'omit' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; });
  };

  ServiceReviews.prototype.render = function (reviews, grades) {
    var self = this;
    var fragment = document.createDocumentFragment();

    var summary = this.summaryCard(grades);
    if (summary) fragment.appendChild(summary);

    reviews.forEach(function (review) {
      /* Der Feed-Titel ist bei Service-Bewertungen immer der abgeschnittene
         Anfang des Kommentars — Bewertungen ohne Kommentar bleiben draussen. */
      if (review && review.comment) fragment.appendChild(self.reviewCard(review));
    });

    if (!fragment.childNodes.length) {
      this.section.hidden = true;
      return;
    }

    this.track.textContent = '';
    this.track.appendChild(fragment);
    this.section.hidden = false;
    this.updateNav();
  };

  ServiceReviews.prototype.stars = function (rating) {
    var value = Math.max(0, Math.min(5, Number(rating) || 0));
    var node = element('span', 'mc-service-reviews__stars');
    node.style.setProperty('--rating-percent', (value * 20) + '%');
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', this.config.labels.starRating.replace('{rating}', value));
    return node;
  };

  ServiceReviews.prototype.gradeLabel = function (rating) {
    var grades = this.config.labels.grades;
    if (rating >= 4.5) return grades.excellent;
    if (rating >= 3.5) return grades.good;
    if (rating >= 2.5) return grades.fair;
    if (rating >= 1.5) return grades.poor;
    return grades.veryPoor;
  };

  ServiceReviews.prototype.dateLabel = function (isoDate) {
    var date = new Date(isoDate);
    if (isNaN(date.getTime())) return '';

    var seconds = (Date.now() - date.getTime()) / 1000;
    if (seconds < 60) return this.config.labels.now;
    if (typeof Intl === 'undefined' || !Intl.RelativeTimeFormat) {
      return date.toLocaleDateString(this.config.locale);
    }

    var formatter = new Intl.RelativeTimeFormat(this.config.locale, { numeric: 'auto' });
    if (seconds < 3600) return formatter.format(-Math.trunc(seconds / 60), 'minute');
    if (seconds < 86400) return formatter.format(-Math.trunc(seconds / 3600), 'hour');
    if (seconds < 604800) return formatter.format(-Math.trunc(seconds / 86400), 'day');
    return date.toLocaleDateString(this.config.locale);
  };

  ServiceReviews.prototype.summaryCard = function (grades) {
    /* Wie im abgeloesten Widget: Note aus den letzten 12 Monaten, Anzahl gesamt. */
    var year = grades && grades.grades && grades.grades['365days'];
    var overall = grades && grades.grades && grades.grades.overall;
    if (!year || !year.rating) return null;

    var card = element('li', 'mc-service-reviews__summary');
    card.appendChild(this.stars(year.rating));
    card.appendChild(element(
      'div',
      'mc-service-reviews__summary-score',
      year.rating.toFixed(2).replace('.', ',')
    ));
    card.appendChild(element('div', 'mc-service-reviews__summary-grade', this.gradeLabel(year.rating)));

    var total = (overall && overall.count) || year.count || 0;
    var countText = this.config.labels.reviewCount.replace(
      '{count}',
      total.toLocaleString(this.config.locale)
    );
    var count = element('div', 'mc-service-reviews__summary-count');

    if (this.config.profileUrl) {
      var link = element('a', null, countText);
      link.href = this.config.profileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      count.appendChild(link);
    } else {
      count.textContent = countText;
    }

    card.appendChild(count);
    return card;
  };

  ServiceReviews.prototype.verifiedIcon = function () {
    var svg = svgNode('svg', {
      'class': 'mc-service-reviews__verified',
      viewBox: '0 0 24 24',
      focusable: 'false'
    });
    svg.appendChild(svgNode('circle', {
      cx: '12', cy: '12', r: '9',
      fill: 'none', stroke: 'currentColor', 'stroke-width': '2'
    }));
    svg.appendChild(svgNode('path', {
      d: 'M7.8 12.4l2.8 2.8 5.6-5.6',
      fill: 'none', stroke: 'currentColor', 'stroke-width': '2',
      'stroke-linecap': 'round', 'stroke-linejoin': 'round'
    }));

    var title = svgNode('title', {});
    title.textContent = this.config.labels.verified;
    svg.appendChild(title);
    return svg;
  };

  ServiceReviews.prototype.reviewCard = function (review) {
    var card = element('li', 'mc-service-reviews__card');
    card.setAttribute('data-mc-sr-card', '');

    var header = element('div', 'mc-service-reviews__card-header');
    header.appendChild(this.stars(review.rating));
    if (review.isVerified) header.appendChild(this.verifiedIcon());
    card.appendChild(header);

    var date = this.dateLabel(review.date);
    if (date) card.appendChild(element('div', 'mc-service-reviews__date', date));

    if (this.config.showAuthor) {
      card.appendChild(element('div', 'mc-service-reviews__author', placeholderAuthor(review.id)));
    }

    card.appendChild(element('p', 'mc-service-reviews__body', review.comment));
    return card;
  };

  ServiceReviews.prototype.cardStep = function () {
    var card = this.track.querySelector('[data-mc-sr-card]') || this.track.firstElementChild;
    if (!card) return this.track.clientWidth;
    var gap = parseFloat(window.getComputedStyle(this.track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  ServiceReviews.prototype.scrollByCard = function (direction) {
    this.track.scrollLeft += direction * this.cardStep();
  };

  ServiceReviews.prototype.updateNav = function () {
    if (!this.prevButton || !this.nextButton) return;
    var maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    this.prevButton.disabled = this.track.scrollLeft <= 0;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
  };

  var instances = new WeakMap();

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(function (root) {
      if (instances.has(root)) return;
      var instance = new ServiceReviews(root);
      instances.set(root, instance);
      instance.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme-Editor: Section wird beim Bearbeiten neu geladen. */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(SELECTOR).forEach(function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
      instances.delete(root);
    });
  });
})();
